import { render, staticRenderFns } from "./HomeText.vue?vue&type=template&id=2b83fa78&scoped=true&"
import script from "./HomeText.vue?vue&type=script&lang=js&"
export * from "./HomeText.vue?vue&type=script&lang=js&"
import style0 from "./HomeText.vue?vue&type=style&index=0&id=2b83fa78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b83fa78",
  null
  
)

export default component.exports